import CultureCodeEnum from '../../../models/culture-code-enum';
import { LoqateAddressFindType } from '../../../models/loqate-address-find-type';
import client from '../client-unauthenticated';

const addressLookup = async (
  countryCode: string,
  text: string
): Promise<LoqateAddressFindType[]> => {
  const { data } = await client.get<LoqateAddressFindType[]>(
    '/address-lookup',
    {
      params: { countryCode, cultureCode: CultureCodeEnum.EnGb, text },
    }
  );

  return data;
};

export default addressLookup;
